(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('VerifytxCredential', VerifytxCredential);

    VerifytxCredential.$inject = ['$resource'];

    function VerifytxCredential ($resource) {
        var resourceUrl =  'api/verifytx-credentials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByCorporation': {url: 'api/verifytx-credentials/corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
